/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Col_KindInputs */

const en_fw_bm_col_kind = /** @type {(inputs: Fw_Bm_Col_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kind`)
};

const id_fw_bm_col_kind = /** @type {(inputs: Fw_Bm_Col_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis`)
};

/**
* | output |
* | --- |
* | "Kind" |
*
* @param {Fw_Bm_Col_KindInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_col_kind = /** @type {((inputs?: Fw_Bm_Col_KindInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Col_KindInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_col_kind(inputs)
	return en_fw_bm_col_kind(inputs)
});